import React, { Component } from 'react';

class redirection_complete extends Component {
  constructor(props){
    super(props);
    this.state = {
      
    };
  }
  componentDidMount(){
    let method = null;
    try{
      let queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);
      method = urlParams.get('method')
    }catch(e){
      console.log(e)
    }

    if(method != null){
      localStorage.current_method = method;
      localStorage.redirection_complete = "true"
    }
  }
  render() {
    return(
      <div className="redirection_complete">
        <h1>Loading...</h1>
      </div>
    )
  }
}

export default redirection_complete;
